import React from "react";
import { format } from "date-fns";

/**
 * Banner component displaying the active managing organisation, platform logo, and last sync timestamp.
 *
 * @param {Object} props
 * @param {Object} props.selectedConnection - Currently focused platform connection
 * @param {Array<Object>} props.platforms - Supported accounting platform definitions
 * @param {Function} props.getPlatformDisplayName - Helper to format platform slug to readable name
 * @returns {React.ReactElement|null}
 */
export default function ManagingOrganisationBanner({
  selectedConnection,
  platforms,
  getPlatformDisplayName
}) {
  if (!selectedConnection) return null;

  const logoColor = platforms.find(p => p.key === selectedConnection.platform)?.logoColor || '#6b7280';

  return (
    <div className="managing-org-banner d-flex align-items-center p-3 rounded mb-4 border bg-white shadow-sm gap-3 justify-content-between">
      <div className="d-flex align-items-center gap-3">
        <div
          className="platform-logo-circle managing-org-logo d-flex align-items-center justify-content-center text-white font-weight-bold"
          style={{ backgroundColor: logoColor }}
        >
          {selectedConnection.platform?.charAt(0).toUpperCase()}
        </div>
        <div>
          <h4 className="font-weight-bold text-dark text-uppercase mb-1 text-start form-label-uppercase">
            Managing Organisation
          </h4>
          <div className="d-flex align-items-center gap-2 flex-wrap managing-org-details">
            <span className="font-weight-bold text-dark managing-org-name">
              {selectedConnection.display_name}
            </span>
            <span className="text-muted managing-org-dot">·</span>
            <span className="small text-muted managing-org-platform">
              {getPlatformDisplayName(selectedConnection.platform)}
            </span>
          </div>
        </div>
      </div>
      {selectedConnection.updatedAt && (
        <div className="text-end">
          <p className="mb-0 small managing-org-subtext">Last synced</p>
          <p className="font-weight-bold mb-0 small font-mono">
            {format(new Date(selectedConnection.updatedAt), 'dd/MM/yyyy, hh:mm a')}
          </p>
        </div>
      )}
    </div>
  );
}

